import { render, staticRenderFns } from "./SessionParticipants.vue?vue&type=template&id=3d8c55a4&"
import script from "./SessionParticipants.vue?vue&type=script&lang=js&"
export * from "./SessionParticipants.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports